import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import translationService from '../../services/translationService';
import styles from './ProductCard.module.css';

function ProductCard({ product, lang = 'en' }) {
  const navigate = useNavigate();
  const isOffer = product.isOffer || false;
  const isAman = product.isAman || false;
  const cardClassName = `${styles.productCard} ${isOffer ? styles.offer : ''} ${isAman ? styles.aman : ''}`;

  // Get translated content based on language
  const getTranslatedContent = (field) => {
    return translationService.getTranslatedContent(product, field, lang);
  };

  // Format price to USD with safety check for undefined values
  const formatPrice = (price) => {
    const numPrice = Number(price);
    if (isNaN(numPrice)) {
      return '$0';
    }
    return '$' + numPrice.toLocaleString('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };



  const handleSeeDetails = (e) => {
    e.preventDefault();
    navigate(`/product/${product.id}`);
  };

  // Default image if product image is not available
  const defaultImage = '/placeholder-image.jpg';

  const seeDetailsText = {
    en: 'See Details',
    ar: 'عرض التفاصيل',
    tr: 'Detayları Gör',
  }[lang];

  return (
    <div className={cardClassName}>
      {isAman ? (
        // For Aman products - not clickable, view only
        <div className={styles.productContent}>
          <div className={styles.imageContainer}>
            <img 
              src={product.imageUrl || defaultImage}
              alt={product.name || 'Product Image'}
              className={styles.productImage}
              onError={(e) => {
                e.target.src = defaultImage;
                e.target.onerror = null;
              }}
            />
          </div>
          <div className={styles.productInfo}>
            <h3 className={styles.productName}>{getTranslatedContent('name') || 'Untitled Product'}</h3>
            <p className={styles.productDescription}>
              {getTranslatedContent('description') && getTranslatedContent('description').length > 100
                ? `${getTranslatedContent('description').substring(0, 100)}...`
                : getTranslatedContent('description') || 'No description available'}
            </p>
            <div className={styles.priceContainer}>
              {Number(product.price) > 0 && (
                <span className={styles.originalPrice}>{formatPrice(product.price)}</span>
              )}
              {Number(product.amanPrice) > 0 && (
                <span className={styles.amanPrice}>{formatPrice(product.amanPrice)}</span>
              )}
              <span className={styles.discount}>In-Store Price</span>
            </div>
          </div>
          <div className={styles.storeOnlyButton}>
            <span>متوفر فقط في المتجر الفعلي</span>
          </div>
        </div>
      ) : (
        // For regular and offer products - clickable with see details button
        <>
          <Link to={`/product/${product.id}`} className={styles.productLink}>
            <div className={styles.imageContainer}>
              <img 
                src={product.imageUrl || defaultImage}
                alt={product.name || 'Product Image'}
                className={styles.productImage}
                onError={(e) => {
                  console.log('Image load error:', e);
                  e.target.src = defaultImage;
                  e.target.onerror = null; // Prevent infinite loop
                }}
              />
            </div>
            <div className={styles.productInfo}>
              <h3 className={styles.productName}>{getTranslatedContent('name') || 'Untitled Product'}</h3>
              <p className={styles.productDescription}>
                {getTranslatedContent('description') && getTranslatedContent('description').length > 100
                  ? `${getTranslatedContent('description').substring(0, 100)}...`
                  : getTranslatedContent('description') || 'No description available'}
              </p>
              <div className={styles.priceContainer}>
                {isOffer ? (
                  <>
                    {Number(product.price) > 0 && (
                      <span className={styles.originalPrice}>{formatPrice(product.price)}</span>
                    )}
                    {Number(product.offerPrice) > 0 && (
                      <span className={styles.offerPrice}>{formatPrice(product.offerPrice)}</span>
                    )}
                    {Number(product.price) > 0 && Number(product.offerPrice) > 0 && (
                      <span className={styles.discount}>
                        {Math.round(((product.price - product.offerPrice) / product.price) * 100)}% OFF
                      </span>
                    )}
                  </>
                ) : (
                  Number(product.price) > 0 && (
                    <span className={styles.productPrice}>{formatPrice(product.price)}</span>
                  )
                )}
              </div>
            </div>
          </Link>
          <button 
            className={styles.seeDetailsButton}
            onClick={handleSeeDetails}
          >
            <FaEye />
            <span>{seeDetailsText}</span>
          </button>
        </>
      )}
    </div>
  );
}

export default ProductCard;